import { Box, Grid } from "@mui/material";
import React from "react";

const OtherRelations = (props) => {
  const { list, click } = props;

  let leftArray = [];
  let rightArray = [];

  for (let i = 0; i < list.length; i++) {
    const element = list[i];
    if (element.relationship === "Pet") {
      leftArray.push(element);
    } else {
      rightArray.push(element);
    }
  }

  const style = {
    position: "absolute",
    bottom: "10px",
    right: 0,
    width: "15px",
    cursor: "pointer",
  };
  return (
    <Grid container>
      <Grid
        item
        lg={6}
        sx={{
          display: "flex",
          flexDirection: "column",
          alignItems: "center",
        }}
        className="left"
      >
        {leftArray.map((item) => (
          <>
            <Box
              component="div"
              sx={{
                position: "relative",
                marginTop: "0.8rem",
                width: "50px",
              }}
            >
              <img
                src={item.profilePicture}
                style={{
                  borderRadius: "50%",
                }}
                alt="pet"
                className={`user-image ${item.shadow && "icon-box-shadow"}`}
              />
              <img
                src={item.edit}
                alt="edit"
                style={style}
                onClick={() => click(item, "edit")}
              />
            </Box>
            <p className="text-eclipse" data-title={item.firstName}>
              {item.firstName.slice(0, 5)}
            </p>
          </>
        ))}
      </Grid>
      <Grid
        item
        lg={6}
        sx={{
          display: "flex",
          flexDirection: "column",
          alignItems: "center",
        }}
      >
        {rightArray.map((item) => (
          <>
            <Box
              component="div"
              sx={{
                position: "relative",
                marginTop: "0.8rem",
                width: "50px",
              }}
            >
              <img
                src={item.profilePicture}
                alt="friend"
                style={{
                  borderRadius: "50%",
                }}
                className={`user-image ${item.shadow && "icon-box-shadow"}`}
              />
              <img
                src={item.edit}
                alt="edit"
                style={style}
                onClick={() => click(item, "edit")}
              />
              {item.isAliveImage && (
                <img
                  src={item.isAliveImage}
                  alt="edit"
                  style={{
                    position: "absolute",
                    top: "10px",
                    left: 0,
                    width: "15px",
                  }}
                />
              )}
            </Box>
            <p className="text-eclipse">{item.firstName}</p>
            <p className="text-eclipse">{item.lastName}</p>
          </>
        ))}
      </Grid>
    </Grid>
  );
};

export default OtherRelations;
